import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

class JobCompact extends Component {

  getSalaryText = (salarioMinimo, salarioMaximo) => {
    if (salarioMinimo != null && salarioMaximo != null)
      return salarioMinimo + " - " + salarioMaximo;
    if (salarioMinimo == null && salarioMaximo == null)
      return "Competitivo";
    if (salarioMinimo != null)
      return "Desde " + salarioMinimo + " €";
    if (salarioMaximo != null)
      return "Hasta " + salarioMaximo + " €";
  }

  getTitleText = (text) => {
    if (text == null) return "";
    return text != null && text.length > 80 ? text.substring(0, 80).toUpperCase() : text.toUpperCase();
  }

  getCompactText = (text) => {
    if (text == null) return "";
    return text != null && text.length > 120 ? text.substring(0, 120) + "..." : text;
  }
  
  render() {
    const { job, onClick } = this.props;

    return (
      <Fragment>
        
        <div className="col-md-4">
          <div className="card" style={ {"minHeight": "18em", cursor: 'pointer'}} onClick={onClick}>
            <div className="card-body">
              <div className="card-title colorDefault h6" style={{height: "4em"}}>
                <Link to={"/jobs/" + job.id}><strong>{ this.getTitleText(job.publishedTitle) }</strong></Link>
              </div>
              <p className="card-text" style={ {height: "6em"}}>{ this.getCompactText(job.publishedText) }</p>
              <p className="card-text"><i className="fas fa-map-marker-alt colorDefault"></i> { job.provincia.name }</p>
              <p className="card-text"><i className="fas fa-euro-sign colorDefault"></i> {  this.getSalaryText(job.salarioMinimo, job.salarioMaximo) }</p>
            </div>
          </div>
        </div>
       
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return { };
};

export default connect(
  mapStateToProps,
  {
    
  }
)(JobCompact);
